import { Observable } from 'rxjs';

export abstract class ILibHandleHttpError {
    abstract HandleError(error: any): Observable<any>
}
